import React, { useState } from "react";
import Container from "../../components/Container/Container";
import Table from "../../components/Table/Table";
import { API, ROUTER } from "../../constants/env";
import swal from "sweetalert";
import moment from "moment";

const ListExam = () => {
  const fields = [
    { title: "Matiere", field: "subject" },
    { title: "classe", field: "classe" },
    { title: "date", field: "date" },
    { title: "trimestre", field: "semester" },
  ];
  const [data, setData] = useState([]);

  const fetchData = (
    currentPage,
    count,
    search,
    setTotalPage,
    setTotal,
    idClasse
  ) => {
    fetch(
      API.exam.list +
        `?page=${currentPage}&count=${count}&searchQuery=${search}&filterByClasse=${idClasse}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
      }
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          return swal("Error", response.message, "error");
        }

        const result = response.data.map(
          ({
            _id,
            period,
            date,
            endHour,
            startHour,
            startDate,
            endDate,
            subject,
            classe,
            semester,
          }) => ({
            _id,
            subject: subject.name,
            classe: classe.map((elem) => `${elem.name}, `),
            semester,
            date: period
              ? `${moment(startDate).format("yyyy-MM-DD")} --> ${moment(
                  endDate
                ).format("yyyy-MM-DD")}`
              : `${moment(date).format(
                  "yyyy-MM-DD"
                )} ( ${startHour} --> ${endHour} )`,
          })
        );
        setData(result);
        setTotalPage(response.totalPage);
        setTotal(response.total);
      })
      .catch((e) => {
        return swal("Error", e.message, "error");
      });
  };
  return (
    <Container
      name="Liste des Examens"
      actionRoute={ROUTER.EXAMENS.CREATE}
      actionName="Ajouter un Examen"
    >
      <Table
        pageName="exam"
        name="Les Examens"
        classeApi={API.classes.all}
        fields={fields}
        data={data}
        editRoute={(id) => ROUTER.EXAMENS.EDIT(id)}
        deleteApiRoute={API.exam.delete}
        deleteMultiple={API.exam.deleteMultiple}
        fetchData={fetchData}
        showSearch={true}
      />
    </Container>
  );
};

export default ListExam;
